import React from "react";
import styled from "styled-components";

export default styled.section`
    margin-top: 15px;
`;